import { BlogApi } from "../Api/BlogApi";

export default (pagination: any, blogContentId:string, isBlock:boolean): BlogComponent => {
    return {
        pagination: pagination,
        filters: [],
        hideInitial: false,
        searchQuery: '',
        blogContentId:blogContentId,
        isBlock:isBlock,
        async onPaginationNextPageClick(event: any) {
            const res = await BlogApi.get(event.detail.currentPage, this.filters, this.searchQuery, this.blogContentId, this.isBlock);
            this.posts = [...this.posts, ...res.posts];
            this.pagination = res.pagination;
        },
        async onFilterClick(filter: string) {
            if (this.filters.some(x => x === filter)) {
                this.filters = this.filters.filter(x => x !== filter);
            } else {
                this.filters.push(filter);
            }
            const res = await BlogApi.get(1, this.filters, this.searchQuery, this.blogContentId, this.isBlock);
            this.hideInitial = true;
            this.posts = [...res.posts];
            this.pagination = res.pagination;
        },
        async onSearch() {
            const res = await BlogApi.get(1, this.filters, this.searchQuery, this.blogContentId, this.isBlock);
            this.hideInitial = true;
            this.posts = [...res.posts];
            this.pagination = res.pagination;
        },

        filterPosts() {
            this.onSearch();
        },
        posts: []
    };
};

import { AlpineComponent } from "alpinejs";
import { IPagination } from "../models/IPagination";

type BlogComponent = AlpineComponent<{
    onPaginationNextPageClick: Function,
    onFilterClick: Function,
    onSearch: Function,
    filterPosts: Function,
    filters: Array<any>,
    posts?: any,
    hideInitial: boolean,
    searchQuery: string,
    pagination: IPagination,
    blogContentId:string,
    isBlock:boolean,
}>;
